<template>
  <div>
    <b-container fluid>
      <b-row>
        <b-col>
          <h2>Eventos de {{ username }}</h2>

          <b-form-group
            label="Pesquisa"
            label-for="filterInput"
            class="mt-4"
          >
            <b-input-group>
              <b-form-input
                v-model="filter"
                type="search"
                id="filterInput"
                placeholder="Digite para pesquisar"
              ></b-form-input>
              <b-input-group-append>
                <b-button :disabled="!filter" @click="filter = ''">Limpar</b-button>
              </b-input-group-append>
            </b-input-group>
          </b-form-group>

          <b-table striped hover
            class="mt-4"
            :items="items"
            :fields="fields"
            :sort-by.sync="sortBy"
            :sort-desc.sync="sortDesc"
            sort-direction="desc"
            :filter="filter"
            primary-key="id"
            sort-icon-left
          >

            <template v-slot:cell(action_access)="data">
              <toggle-button
                :value="data.item.can_access"
                :sync="true" :width="60" :height="30"
                :color="{checked: '#26A65B', unchecked: '#E74C3C'}"
                @change="switchAccess(userId, data.item.id)"
              />
            </template>

          </b-table>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>

<script>
import ToggleButton from 'vue-js-toggle-button/src/Button'

export default {
  name: 'AdminUsersEvents',
  props: [
    'username'
  ],
  components: {
    ToggleButton
  },
  data () {
    return {
      filter: '',
      fields: [
        {key: 'name', label: 'Evento', sortable: true},
        {key: 'date', label: 'Data', formatter: this.$options.filters.date},
        {key: 'action_access', label: 'Pode acessar?', sortable: true}
      ],
      items: [],
      sortBy: 'id',
      sortDesc: true,
      userId: parseInt(this.$route.params.id)
    }
  },
  async created () {
    await this.getUserEvents(this.userId)
  },
  methods: {
    async getUserEvents (userId) {
      try {
        let users = await this.$http.get(process.env.VUE_APP_URL_APP + `/b/admin/users/${userId}/events`)
        this.items = users.body.events
      } catch (err) {
        console.error(err)
      }
    },
    async switchAccess (userId, eventId) {
      try {
        let res = await this.$http.put(process.env.VUE_APP_URL_APP + `/b/admin/users/${userId}/events/${eventId}/access`, {})
        let j = this.$_.findIndex(this.items, o => o.id === eventId)
        this.items[j].can_access = res.body.enabled
      } catch (err) {
        console.error(err)
      }
    }
  }
}
</script>
